import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../components/ui/confirmation-dialog/confirmation-dialog.component';
import { FacilitatorInfo } from '../components/transfer-visualization/transfer-visualization.component';
import { MailerService } from 'src/app/services/mailer.service';

@Component({
    selector: 'app-retrieve-instructions',
    templateUrl: './retrieve-instructions.component.html',
    styleUrls: ['./retrieve-instructions.component.scss'],
    standalone: false
})
export class RetrieveInstructionsComponent {
  @Input() patientId?: string;
  @Input() senderFacility?: string;
  @Input() targetFacility?: string;
  @Input() caseName?: string;
  @Input() facilitators: FacilitatorInfo[] = [];

  constructor(
    private dialog: MatDialog,
    private mailerService: MailerService
  ) { }
 

  async notifyFacilityUsers(): Promise<void> {
    // Generate the link
    if (!this.patientId || !this.senderFacility || !this.targetFacility) {
      console.warn('Cannot generate link: missing required parameters', {
        patientId: this.patientId,
        senderFacility: this.senderFacility,
        targetFacility: this.targetFacility
      });
      
      const errorDialogConfig = new MatDialogConfig();
      errorDialogConfig.width = '400px';
      errorDialogConfig.data = {
        title: 'Error',
        message: 'Missing required information to generate notification link',
        btnOkText: 'OK',
        btnCancelText: 'Close'
      };
      this.dialog.open(ConfirmationDialogComponent, errorDialogConfig);
      return;
    }

    const link = `http://localhost:4200/image-exchange/${this.patientId}/from/${this.senderFacility}/to/${this.targetFacility}/images/retreive`;
    console.log('Generated notification link:', link);

    // Send emails to facilitators
    if (this.facilitators && this.facilitators.length > 0) {
      const destinationEmails = this.facilitators
        .map(f => f.email)
        .filter(email => email && email.trim() !== '');

      if (destinationEmails.length > 0) {
        // Set up the email notification using sendSendImagesEmailNotification() method
        // First, set the destination emails
        this.mailerService.setDestinationEmails(destinationEmails);
        
        // Then, set the message data with required fields for shared-image-access
        this.mailerService.sendImagesNotificationEmail = {
          messageData: {
            targetEmail: destinationEmails[0],
            caseName: this.caseName || this.patientId || 'Unknown',
            link: link,
            senderFacilityName: this.senderFacility || 'A facility'
          }
        };

        try {
          // Call the sendSendImagesEmailNotification() method
          await this.mailerService.sendSendImagesEmailNotification();
          console.log('Emails sent successfully to facilitators:', destinationEmails);
        } catch (error) {
          console.error('Error sending emails:', error);
        }
      } else {
        console.warn('No valid email addresses found in facilitators');
      }
    } else {
      console.warn('No facilitators provided to send notifications to');
    }

    // Show confirmation message
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '400px';
    dialogConfig.data = {
      title: 'Notification Sent',
      message: 'The notifications have been sent to all users in the facility',
      btnOkText: 'OK',
      btnCancelText: 'Close'
    };

    this.dialog.open(ConfirmationDialogComponent, dialogConfig);
  }

}
